var DatePicker = require('modules/date-picker');
var DISABLE_CLASS = 'button--disabled';

function formatDate(date) {
	var month = date.getMonth() + 1;
	if (month < 10) {
		month = '0' + month;
	}
	return date.getFullYear() + '-' + month + '-' + (date.getDate() < 10 ? '0' : '') + date.getDate();
}

function revertDate(date) {
	return formatDate(date).replace(/-/g, '/');
}

function selectAll(selector, parent) {
	return Array.prototype.slice.call(parent.querySelectorAll(selector));
}

function disableButton(button) {
	button.disabled = true;
	button.classList.add(DISABLE_CLASS);
}

function enableButton(button) {
	button.disabled = false;
	button.classList.remove(DISABLE_CLASS);
}

function Form(el) {
	var t = this;
	var datePickers = selectAll('.js-date-picker', el);
	var forms = selectAll('form', el);
	var buttons = selectAll('button, input[type="submit"], a.button, .js-button', el);
	var areFormsEnabled = true;

	var reserveChangeCheckbox = selectAll('.js-reserve-change-checkbox', el);
	var rewardsFormSubmit = selectAll('.js-rewards-form-submit', el);
	if (rewardsFormSubmit) {
		rewardsFormSubmit.map(disableButton);
	}

	if (reserveChangeCheckbox) {
		reserveChangeCheckbox.map(function (checkbox) {
			checkbox.addEventListener('change', function(e) {
				if (e.target.checked) {
					rewardsFormSubmit.map(enableButton);
				} else {
					rewardsFormSubmit.map(disableButton);
				}
			});
		});
	}

	forms.map(function(form) {
		form.addEventListener('submit', function(e) {
			if (!areFormsEnabled) {
				e.preventDefault();
				return false;
			}

			areFormsEnabled = false;
			buttons.map(disableButton);
		});
	});

	// Enable Date Picker
	if( datePickers ) {
		datePickers.forEach( function(elem) {
			var args = {
				format: formatDate
			};
			var min = elem.getAttribute('data-min');

			if ( ! min ) {
				min = new Date();
				var offset = elem.getAttribute('data-offset') || 0;
				min.setSeconds(min.getSeconds() + min.getTimezoneOffset() * 60 + parseInt(offset));
				min = formatDate(min);
			} else {
				min = min.replace('-', '/');
			}
			args.min = min;
			args.max = elem.getAttribute('data-max');
			if (args.max) {
				args.max = args.max.replace('-', '/');
			}

			var unavailable = elem.getAttribute('data-unavailable');

			if (unavailable) {
				unavailable = unavailable.split(',');
				args.inRange = function(dt) {
					return unavailable.indexOf(revertDate(dt)) === -1;
				};
			}

			t.calendar = new DatePicker(elem, args);
    });
  }
}

module.exports = Form;
